<template>
    <div class="dropdown" id="ageFilterDropdown">
        <b-button-group>
            <button class="btn btn-white" @click="clearAgeRange" v-if="ageRange || ages.length">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown variant="white" right :text="$t('By age')">
                <div class="dropdown-item pl-3" v-if="multiple" v-for="(label, index) in labels" :key="index">
                    <b-form-checkbox v-model="ages" :value="label.value">
                        {{label.text}}
                    </b-form-checkbox>
                </div>
                <b-dropdown-item v-else href="#" v-for="(label, index) in labels" :key="index" @click="setAgeRange(label.value)">
                    {{label.text}}
                </b-dropdown-item>
            </b-dropdown>
        </b-button-group>
    </div>
</template>

<script>
    export default {
        name: "AgeFilter",
        props: {multiple: Boolean},
        data() {
            return {
                labels: [
                    {text: '0 - 14', value: {$gte: 0, $lte: 14}},
                    {text: '15 - 24', value: {$gte: 15, $lte: 24}},
                    {text: '25 - 44', value: {$gte: 25, $lte: 44}},
                    {text: '45 - 64', value: {$gte: 45, $lte: 64}},
                    {text: '65+', value: {$gte: 65, $lte: 100}},
                ],
                ages: [],
                ageRange: null
            }
        },
        mounted() {
        },
        computed: {},
        watch: {
            ages(newValue) {
                this.emit()
            }
        },
        methods: {
            clearAgeRange() {
                this.ageRange = null;
                this.ages = [];
                this.emit();
            },

            setAgeRange(range) {
                this.ageRange = range;
                this.emit()
            },

            emit() {
                if (this.multiple) this.$emit('input', this.ages.length ? this.ages : null);
                else this.$emit('input', this.ageRange)
            }
        },
    }
</script>

<style scoped>

</style>
